export default __webpack_public_path__ + "static/media/dashboard.49852f26.webp";